import React, { ReactElement, useState } from 'react';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { OverlayTriggerProps } from 'react-bootstrap/esm/OverlayTrigger';

/**
 *  A generic tooltip component.
 *
 * Usages
 *
 * 1. Can be used as a wrapper eg: <Tooltip tooltip="some text"><Button></>Button></Tiiltip>
 *   In this case UI will display the button component and when hovered over it, tooltip will be shown. If
 *  'tooltip' prop is undefined then we just return the child component.
 *
 * 2. Can be placed next to a component eg; <h2>Heading<h2> <Tooltip tooltip="Some text"/>
 *   In this case UI will display an info icon next to 'Heading' and when hovered over the icon, tooltip will be shown
 */

export default function RetainOverlayTrigger(props: OverlayTriggerProps) {
	const [showTooltip, setShowTooltip] = useState(false);
	const { overlay, children } = props;
	const tooltip = overlay as ReactElement;
	const Child = children as ReactElement ?? <i className="fas fa-info-circle text-primary" />;
	if (tooltip === undefined) {
		return Child;
	}
	return (
		<OverlayTrigger
			
			trigger={props.trigger ?? ['hover', 'focus']}
			{...props}
			// onEnter={() => setShowTooltip(true)}
			onToggle={() => setShowTooltip(!showTooltip)}
			overlay={<Tooltip
				id={Child.key + "-tooltip"}
				className="content-enhancer-tooltip"
				onMouseEnter={() => setShowTooltip(true)}
				onMouseLeave={() => setShowTooltip(false)}
			>
				{tooltip}
			</Tooltip>}
			show={showTooltip}
		>
			<span onMouseEnter={() => setShowTooltip(true)} onMouseLeave={() => setShowTooltip(false)}>
				{Child}
			</span>
		</OverlayTrigger>
	);
}
